import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import store from './store';
import Routes from './routes';
import reportWebVitals from './reportWebVitals';
import { GlobalStateProvider } from './components/GlobalState';
import { I18nProvider } from './i18n/I18nContext';

ReactDOM.render(
  <React.StrictMode>
     <GlobalStateProvider>
        <Provider store={store}>
          <I18nProvider>
            <Routes />
          </I18nProvider>
        </Provider>
    </GlobalStateProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

reportWebVitals();
